import { restoreValue, persistValue } from "../utils/local_storage_form";

const KEY_NAME = "spot_comment_author_name";
const KEY_EMAIL = "spot_comment_author_email";

document.addEventListener("DOMContentLoaded", () => {
  const nameInput = document.getElementById("contribution_contact_name");
  const emailInput = document.getElementById("contribution_contact_email");
  if (!nameInput && !emailInput) return;

  restoreValue(nameInput, KEY_NAME);
  restoreValue(emailInput, KEY_EMAIL);

  persistValue(nameInput, KEY_NAME);
  persistValue(emailInput, KEY_EMAIL);
});
